import { useQuery } from "@tanstack/react-query";
import { getSaTemplate } from "apis";
import { getMe } from "../../utils/bridges/methods";

const useGetSaTemplate = (
  {
    selectedDoctorOid,
    enabled,
  }: {
    selectedDoctorOid?: string;
    enabled?: boolean;
  } = { enabled: true }
) => {
  const { user } = getMe();
  const docId = selectedDoctorOid || user["doc-id"];
  return useQuery(
    ["get-sa-template", docId],
    () =>
      getSaTemplate({
        doctorOid: selectedDoctorOid || user["doc-id"],
      }),
    {
      staleTime: 5 * 60 * 1000,
      enabled: enabled && docId ? true : false,
    }
  );
};

export default useGetSaTemplate;
